import React, { Fragment, useEffect, useState } from "react";
import Select from "react-select";
import customStyles from "./SelectFeild";

const SelectGrnAccount = ({ data, isSuccess, handleVendorChange, selected }) => {
  let [grnDw, setGrnDw] = useState([]);

  useEffect(() => {
    let poLists = [];
    if (Array.isArray(data) && data.length > 0) {
      data.forEach((po) => {
        poLists.push({
          option: po._id,
          value: po._id,
          label: `${po.grnNo || ""} - ${(po.total || 0).toFixed(2)} BDT${
            po.supplier?.company ? ` (${po.supplier.company})` : ""
          }`,
          grn: po,
        });
      });
    }
    setGrnDw(poLists);
  }, [data, isSuccess]);

  const selectedOption =
    selected && grnDw.length > 0
      ? grnDw.find(
          (item) => item.option === selected || item.value === selected
        ) || null
      : null;

  return (
    <Fragment>
      <Select
        className="basic-single"
        classNamePrefix="select"
        styles={customStyles}
        placeholder="Select Grn No"
        value={selectedOption}
        isDisabled={false}
        isLoading={!isSuccess && !data}
        isClearable={true}
        isSearchable={true}
        name="grnNo"
        onChange={handleVendorChange}
        options={grnDw}
      />

      <div
        style={{
          color: "hsl(0, 0%, 40%)",
          display: "inline-block",
          fontSize: 12,
          fontStyle: "italic",
          marginTop: "1em",
        }}
      ></div>
    </Fragment>
  );
};

export default SelectGrnAccount;
